import { getItemFromStorage } from "../helper/storage";
import { authorizedFetch, baseUrl, buildHeaders, getResponseOrThrow } from "../redux/api/common";

export const apiGetNotifications = async () => {
  const token = getItemFromStorage("TOKEN");
  const manager_id = getItemFromStorage("MANAGER_ID");

  try {
    const response = await authorizedFetch(
      `${baseUrl}/manager/${manager_id}/notifications`,
      {
        method: "GET",
        headers: buildHeaders(token)
      }
    );
    return getResponseOrThrow(response);
  } catch (error) {
    return await Promise.reject(error);
  }
};
